export const SR_GET_USER_SETTINGS_REQUEST = 'SWAP_REINVESTMENT/GET_USER_SETTINGS_REQUEST';
export const SR_GET_USER_SETTINGS_SUCCESS = 'SWAP_REINVESTMENT/GET_USER_SETTINGS_SUCCESS';
export const SR_POST_USER_SETTING_REQUEST = 'SWAP_REINVESTMENT/POST_USER_SETTING_REQUEST';
export const SR_POST_USER_SETTING_SUCCESS = 'SWAP_REINVESTMENT/POST_USER_SETTING_SUCCESS';
export const SR_PATCH_USER_SETTING_REQUEST = 'SWAP_REINVESTMENT/PATCH_USER_SETTING_REQUEST';
export const SR_PATCH_USER_SETTING_SUCCESS = 'SWAP_REINVESTMENT/PATCH_USER_SETTING_SUCCESS';
export const SR_PATCH_USER_STATUS_REQUEST = 'SWAP_REINVESTMENT/PATCH_USER_STATUS_REQUEST';
export const SR_PATCH_USER_STATUS_SUCCESS = 'SWAP_REINVESTMENT/PATCH_USER_STATUS_SUCCESS';
export const SR_RESET_USER_INPUT = 'SWAP_REINVESTMENT/RESET_USER_INPUT';
export const SR_INITIALIZE_USER_INPUT = 'SWAP_REINVESTMENT/INITIALIZE_USER_INPUT';
export const SR_USER_SETTINGS_LOADING = 'SWAP_REINVESTMENT/USER_SETTINGS_LOADING';
export const SR_CHANGE_INPUT_VALUE = 'SWAP_REINVESTMENT/CHANGE_INPUT_VALUE';
export const SR_ADD_INPUT_ERROR = 'SWAP_REINVESTMENT/ADD_INPUT_ERROR';
export const SR_REMOVE_INPUT_ERROR = 'SWAP_REINVESTMENT/REMOVE_INPUT_ERROR';
export const SR_RESET_INPUT_ERROR = 'SWAP_REINVESTMENT/RESET_INPUT_ERROR';
